module.exports = __webpack_public_path__ + "static/img/activity-notification.cfa6295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity-notification.png
// module id = s29K
// module chunks = 36